/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Bühler
 * Date: 12.02.2016
 *
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Container, Col, FormLabel, FormControl, FormGroup, Row } from 'external/react-bootstrap';
import { AppContext, DataLinkContainer, DataUtil, ScrollableDataListRV, Title } from 'plugin/liferay-widgets-react-web';
import { GROUP_NAMED_LISTS } from '../constants/Constants';
import NamedListListItem from '../components/NamedListListItem';
import { getNamedListStore } from '../stores/StoreFactory';

const NamedListStore = getNamedListStore(AppContext);
const NamedListListLinkCHOC = DataLinkContainer.link(ScrollableDataListRV, ['list'], NamedListStore);

class BomListWidgetConfigForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            namedList: undefined
        };

        this.selectNamedList = this.selectNamedList.bind(this);
        this.onChangeHeight = this.onChangeHeight.bind(this);
    }

    componentDidMount() {
        const assetCategoryId = this.props.formData && this.props.formData.assetCategoryId || -1;
        if (assetCategoryId > 0) {
            const namedListsDataItem = NamedListStore.getRemoteData(GROUP_NAMED_LISTS);
            const namedLists = DataUtil.asArray(namedListsDataItem);
            const namedList = namedLists && namedLists.filter(list => list.id == assetCategoryId)[0];
            this.setState({
                namedList
            });
        }
    }

    selectNamedList(namedList) {
        this.change({ assetCategoryId: namedList.id });
        this.setState({ namedList });
    }

    onChangeHeight(e) {
        this.change({ height: e.target.value });
    }

    change(o) {
        const formData = { ...this.props.formData, ...o };
        this.props.onChange(formData);
    }

    render() {
        const { formData } = this.props;
        return (
            <Container fluid>
                <fieldset>
                    <Title title={'Liste auswählen'}/>
                    <Row>
                        <Col xs={12} sm={4}>
                            <FormGroup controlId="formControlsGaugingStationheight">
                                <FormLabel>
                                    Höhe (in Pixel)
                                </FormLabel>
                                <FormControl
                                    type="number"
                                    step="10.0"
                                    value={formData.height}
                                    onChange={this.onChangeHeight}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <NamedListListLinkCHOC
                                list={GROUP_NAMED_LISTS}
                                activeIds={this.state.namedList}
                                size="large"
                                ListItem={NamedListListItem}
                                onClick={this.selectNamedList}
                            />
                        </Col>
                    </Row>
                </fieldset>
            </Container>
        );
    }
}

BomListWidgetConfigForm.propTypes = {
    onChange: PropTypes.func,
    formData: PropTypes.object,
    formValidation: PropTypes.object
};

export default BomListWidgetConfigForm;




// WEBPACK FOOTER //
// ./js/widgets/BomListWidgetConfigForm.jsx